import {StyleSheet} from 'react-native';
import {getWidth} from '@buncha/utils/common';

export const styles = StyleSheet.create({
  updateBox: {
    height: '100%',
    justifyContent: 'space-between',
  },
  flatList: {},
  conatinerBox: {
    // minHeight: Dimensions.get('screen').height / 2.7,
  },
  divider: {
    height: 0.5,
    marginVertical: 5,
  },
  flatListContainer: {
    paddingBottom: 200,
    // flex: 1,
  },
  remainingText: {
    marginRight: 10,
    textAlign: 'right',
  },
  inputStyle: {
    width: getWidth(70),
    height: 20,
  },
  textAlignLeft: {
    textAlign: 'left',
  },
  quantityText: {
    textAlign: 'left',
    marginBottom: 20,
  },
  bottomBox: {
    justifyContent: 'space-between',
    width: '100%',
    alignSelf: 'stretch',
    marginLeft: 5,
    marginBottom: 5,
  },
  quantityContainer: {
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
  },
  quantityPill: {
    borderWidth: 1,
    padding: 10,
    borderRadius: 50,
  },
});
